export const notificationsQueries = {
  list: (params: { page?: number; per_page?: number; query?: string } = {}) => [
    'notifications',
    params,
  ],
};
